import {type RoomProtocolMapperClient} from '../../../../shared/scripts/RoomProtocolMapperClient.ts'
import {AnalyticEventValue} from '../../../../../shared/entity_datas/EntityDatas.ts'
import {DiscordInstance} from '../DiscordInstance.ts'
import {SDKRequest} from '../../../../../shared/DiscordActivityTypes.ts'
import {ColonistMembershipType} from '@colonist/types'
import {ViewPopupBecomeMemberGameplay} from '../../../../shared/scripts/ui_popup/ViewPopupBecomeMemberGameplay.ts'

export function registerDiscordRoomClientHandlers(roomClient: RoomProtocolMapperClient) {
    roomClient.onFailedToStartGameMembershipRequired(() => {
        const analyticEventValue = AnalyticEventValue.PopupMembershipIncentiveDiscordGeneral
        const checkAction = () => {
            void DiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.PurchaseMembership, ColonistMembershipType.PremiumMonthly)
        }
        new ViewPopupBecomeMemberGameplay(checkAction, analyticEventValue)
    }, true)
}
